import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import { useApp } from './store'
import type { Content, Store } from './types'

export function useStoreSelection() {
  const { store, setStore, clear } = useApp()
  const storesQuery = useQuery({ queryKey: ['stores'], queryFn: () => api<Store[]>('/api/h5/stores') })
  const contentQuery = useQuery({ queryKey: ['content'], queryFn: () => api<Content>('/api/h5/content') })
  const stores = storesQuery.data || []
  const singleStore = contentQuery.data?.storeMode === 'SINGLE'

  useEffect(() => {
    if (!stores.length) return
    const currentStore = stores.find((item) => item.id === store?.id)
    if (currentStore && (!singleStore || currentStore.id === stores[0].id)) return
    const savedId = singleStore ? '' : localStorage.getItem('h5StoreId')
    const nextStore = stores.find((item) => item.id === savedId) || stores[0]
    if (store && store.id !== nextStore.id) clear()
    setStore(nextStore)
  }, [clear, setStore, singleStore, store, stores])

  return {
    store,
    setStore,
    stores,
    content: contentQuery.data,
    singleStore,
    canSwitchStore: contentQuery.isError || (!!contentQuery.data && !singleStore)
  }
}
